import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { CARD_MIN_HEIGHT } from "common/constants";

const MainDetails = ({ data }: { data: any }) => {
  return (
    <React.Fragment>
      <Col xxl={9}>
        <Card>
          <CardBody>
            <div className="text-muted">
              <h6 className="mb-2 fw-semibold text-uppercase">
                Sanction Details
              </h6>
            </div>
          </CardBody>
          <CardBody style={{ minHeight: CARD_MIN_HEIGHT }}>
            <div className="fs-13">
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Full Name:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.title || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Reference:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.uniqueID || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">UN Reference No:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.unReferenceNumber || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Designate Type:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.individualEntityShip || "Not Provided"}
                </Col>
              </Row>

              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Alias Names:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.aliasNames || "Not Provided"}
                </Col>
              </Row>

              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Designation Source:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.designationSource || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">OFSI Group Id:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.OFSIGroupId || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Gender:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.gender || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Non Latin Name:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.nonLatinName || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Phone Number:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.phoneNumber || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Email:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.email || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Titles:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.titles || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Date Designated:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.dateDesignated || "Not Provided"}
                </Col>
              </Row>

              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Passport:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.passport || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Passport Details:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.passportDetails || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Date of Birth:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.dateOfBirth || "Not Provided"}
                </Col>
              </Row>

              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Country of Birth:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.countryOfBirth || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Town of Birth:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.townOfBirth || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Address:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.fullAddress || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Nationality:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.nationality || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Country:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.country || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">National Identifier Number:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.nationalIdentifierNumber || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">
                    National Identifier Additional Information
                  </div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.nationalIdentifierAdditionalInformation ||
                    "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Additional Information:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.additionalInformation || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">UK Statements of Reason:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.ukStatementOfReasons || "Not Provided"}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Last Updated:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.lastUpdated || "Not Provided"}
                </Col>
              </Row>
            </div>
          </CardBody>
          <CardBody>
            <div className="text-muted">
              <h6 className="mb-2 fw-semibold text-uppercase">
                Sanctions Imposed
              </h6>
            </div>
          </CardBody>
          <CardBody>
            <div className="fs-13">
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Asset Freeze:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.assetFreeze ? (
                    <span className="badge bg-success-subtle text-success fs-11">
                      Yes
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger fs-11">
                      No
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Arms Embargo:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.armsEmbargo ? (
                    <span className="badge bg-success-subtle text-success fs-11">
                      Yes
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger fs-11">
                      No
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Targeted Arms Embargo:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.targetedArmsEmbargo ? (
                    <span className="badge bg-success-subtle text-success fs-11">
                      Yes
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger fs-11">
                      No
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Chartering of Ships:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.charteringOfShips ? (
                    <span className="badge bg-success-subtle text-success fs-11">
                      Yes
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger fs-11">
                      No
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">
                    Closure of Representative Offices:
                  </div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.closureOfRepresentativeOffices ? (
                    <span className="badge bg-success-subtle text-success fs-11">
                      Yes
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger fs-11">
                      No
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">
                    Crew Servicing of Ships and Aircraft:
                  </div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.crewServicingOfShipsAndAircraft ? (
                    <span className="badge bg-success-subtle text-success fs-11">
                      Yes
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger fs-11">
                      No
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Deflag:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.deflag ? (
                    <span className="badge bg-success-subtle text-success fs-11">
                      Yes
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger fs-11">
                      No
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">
                    Prohibition on Provision of Financial Services:
                  </div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.prohibitionOnProvisionOfFinancialServices ? (
                    <span className="badge bg-success-subtle text-success fs-11">
                      Yes
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger fs-11">
                      No
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Prohibition of Port Entry:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.prohibitionOfPortEntry ? (
                    <span className="badge bg-success-subtle text-success fs-11">
                      Yes
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger fs-11">
                      No
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">Travel Ban:</div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.travelBan ? (
                    <span className="badge bg-success-subtle text-success fs-11">
                      Yes
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger fs-11">
                      No
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">
                    Prevention of Chartering of Ships:
                  </div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.preventionOfCharteringOfShips ? (
                    <span className="badge bg-success-subtle text-success fs-11">
                      Yes
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger fs-11">
                      No
                    </span>
                  )}
                </Col>
              </Row>
              <Row className="px-1 mb-2">
                <Col lg={3} sm={3}>
                  <div className="fw-medium">
                    Technical Assistance Related to Aircraft:
                  </div>
                </Col>
                <Col lg={9} sm={9}>
                  {data?.technicalAssistanceRelatedToAircraft ? (
                    <span className="badge bg-success-subtle text-success fs-11">
                      Yes
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger fs-11">
                      No
                    </span>
                  )}
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default MainDetails;
